var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7679 12.5986L20.8827 7.71339C20.7465 7.57718 20.5626 7.5 20.3697 7.5H10.7264C10.3246 7.5 10 7.82462 10 8.22642V27.1134C10 27.5152 10.3246 27.8398 10.7264 27.8398H25.2549C25.6567 27.8398 25.9813 27.5152 25.9813 27.1134V13.1139C25.9813 12.9209 25.9041 12.7348 25.7679 12.5986ZM24.306 13.4476H20.0337V9.17531L24.306 13.4476ZM24.3469 26.2054H11.6345V9.13445H18.4901V14.0378C18.4901 14.2907 18.5905 14.5332 18.7693 14.712C18.9481 14.8908 19.1906 14.9912 19.4435 14.9912H24.3469V26.2054Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.ed68da3eea13fea88851b4a8b2df62f7.svg";
export { ForwardRef as ReactComponent };